import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyPasteBlockDirective } from './copy-paste-block.directive';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ CopyPasteBlockDirective ],
    exports: [ CopyPasteBlockDirective ],
})
export class CopyPasteBlockDirectiveModule {}
